import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthsFacade } from '@kion/data-access/data-access-auths';
import { CmsConfig } from '../config/cms.config';
import { CorrelationObserverService } from '@kion/ngrx-helper';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { catchError, switchMap, take } from 'rxjs/operators';
import {AuthCheckService} from "../services/auth-check.service";
import { environment } from '../../../../../../apps/dematic/src/environments/environment';

@Injectable()
export class KionInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthsFacade,
    private baseSiteConfig: CmsConfig,
    private correlationObserverService: CorrelationObserverService,
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private authCheckService: AuthCheckService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.authService.all$.pipe(
      take(1),
      switchMap(
        auth => {
          const cmsTicketId = this.route.snapshot.queryParams.cmsTicketId;
          let userLang = this.cookieService.get('_language') || '';
          const userAuth = auth[0]?.user;
          const clientAuth = auth[0]?.client;
          let token = clientAuth?.accessToken;
          let hasClientToken = true;
          if (clientAuth) {
            if (new Date() >= new Date(clientAuth.expireDate)) {
              token = null;
              hasClientToken = false;
            }
          }
          let isUser = false;
          if(userAuth) {
            token = userAuth.accessToken;
            isUser = this.baseSiteConfig.project === 'LR' || this.baseSiteConfig.project === 'Dematic';
            if (userAuth) {
              if (new Date(userAuth.expireDate) <= new Date()) {
                token = null;
                if (hasClientToken) {
                  token = clientAuth?.accessToken;
                }
              }
            }
          }
		  let dematic = this.baseSiteConfig.project == 'Dematic';
		  let funcLoc = this.cookieService.get('_funcLoc');
          let params = {
            'fields': 'FULL'
          };

          if (dematic)
          {
			let dmSite : string[] = [this.cookieService.get('dmSite')];
			
			params = {
              ...params,
              // @ts-ignore
              'dmSite': dmSite
            };
			userLang = this.calculacteAndSetUserLanguage(request);
          }
          if (userLang && userLang.length > 0) {
            params = {
              ...params,
              // @ts-ignore
              'lang': userLang
            };
          }
          if (cmsTicketId && !request.url.includes('basesites') && !request.url.includes('idsearch')) {
            params = {
              ...params,
              // @ts-ignore
              'cmsTicketId': cmsTicketId
            };
          }
          if (token) {
            if(this.baseSiteConfig.project === 'Dematic'){
              //needed to allow multipart requests
              request = request.clone({
                setHeaders: {
                  Authorization: 'Bearer ' + token
                },
                setParams: params,
                url: isUser ? request.url.replace('anonymous', 'current') : request.url
              });
            }
            else{
              request = request.clone({
                setHeaders: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + token
                },
                setParams: params,
                url: isUser ? request.url.replace('anonymous', 'current') : request.url
              });
            }
            return next.handle(request).pipe(
              catchError((err: HttpErrorResponse) => this.catchHttpError(err, request))
            );
          } else {
            request = request.clone({
              setHeaders: {
                'Content-Type': 'application/json',
              },
              setParams: params
            });
            return next.handle(request).pipe(
              catchError((err: HttpErrorResponse) => this.catchHttpError(err, request))
            );
          }
        }
      )
    );
  }

  catchHttpError (err: HttpErrorResponse, request: HttpRequest<unknown>): Observable<HttpEvent<unknown>> {
    if (err.status === 401 || err.status === 500) {
      if (err.error.error === 'invalid_token' || err.error.errors[0].type === 'InvalidTokenError') {
          this.authCheckService.checkTokensAndRefreshIt();
      }
    }
      if (err.status === 400 ) {
          if (err.error.error === 'invalid_grant') {
              this.authCheckService.checkTokensAndRefreshIt();
          }
      }
    if (this.baseSiteConfig.project === 'FS') {
      if (request.url.indexOf('basesites') !== -1 && err.status === 401) {
        //TODO: what now ?
      }
    }
    return throwError(err);
  }

  calculacteAndSetUserLanguage(request: HttpRequest<unknown>): string {
	let cookLang = this.cookieService.get('_language');
	let urlLang = environment.basePath;
	urlLang = urlLang.split("/").join("");
	
	const languageStreaks = urlLang.split('-');
	let selectedLocation = languageStreaks[0] + '_' + languageStreaks[1].toUpperCase();
	
	if (cookLang != selectedLocation) {
		
		let dematic = this.baseSiteConfig.project == 'Dematic';
				
		if (dematic) {
			const valSameSite = 'None';
			this.cookieService.set('_language', selectedLocation, { secure: true, expires: 200000, path: '/', sameSite: valSameSite});
		} else {
			this.cookieService.set('_language', selectedLocation, 200000, "/");
		}
	}
	return selectedLocation;
  }
}
